module.exports = __webpack_public_path__ + "img/icon-arrow-left.84c9b35f.svg";